/*
===============================|> The /categories page tree (QA-362) <|===============================
The page lists the store's category tree: first level on the left, the
active first-level category's children on the right. Which copy of the tree
it lists, and which first-level category is active, are decided here, in
plain functions the page and its tests share.
===============================|> The /categories page tree (QA-362) <|===============================
*/

// a category the page lists: active, with products, included in the menu
// (the API sends include_in_menu as "1" or 1)
export const isListedCategory = (category) =>
  Boolean(category?.is_active) &&
  category?.product_count > 0 &&
  String(category?.include_in_menu) === '1';

export const hasCategories = (tree) =>
  Array.isArray(tree?.children_data) && tree.children_data.length > 0;

// The tree the page draws: the one its server props carry, or - when those
// came without one (an empty data payload answered from a cache, an
// upstream failure during the render) - the copy the layout holds for the
// same locale (useCategoryTree). Null when neither has categories.
export const pickCategoriesTree = (serverTree, clientTree, locale) => {
  if (hasCategories(serverTree)) return serverTree;
  if (clientTree?.locale === locale && hasCategories(clientTree)) {
    return clientTree;
  }
  return null;
};

export const listedCategories = (tree) =>
  (tree?.children_data ?? []).filter(isListedCategory);

// the visitor's pick when it is still listed, else the first category that
// has children to show
export const activeFirstLevel = (categories, selectedId) =>
  categories.find((category) => category.id === selectedId) ??
  categories.find((category) => category.children_data?.length > 0);
